import AffinityIcon from './AffinityIcon'

export default AffinityIcon
